import { create } from "zustand";

const safeInt = (s: string | null, fallback: number): number => {
  const n = parseInt(s ?? "", 10);
  return Number.isFinite(n) ? n : fallback;
};

type TokenBudgetState = {
  tokensUsed: number;
  tokensRemaining: number;
  tokensLimit: number;
  tier: string;
  resetsAt: string | null;
  /** True once at least one token-consuming response has been seen */
  initialized: boolean;
  /** Increments each time an external event (e.g. price alert) should trigger the bolt pop */
  popCount: number;
  actions: {
    updateFromHeaders: (headers: Headers) => void;
    triggerPop: () => void;
  };
};

export const useTokenBudgetStore = create<TokenBudgetState>((set) => ({
  tokensUsed: 0,
  tokensRemaining: 0,
  tokensLimit: 50,
  tier: "free",
  resetsAt: null,
  initialized: false,
  popCount: 0,
  actions: {
    triggerPop: () => set((s) => ({ popCount: s.popCount + 1 })),
    updateFromHeaders: (headers: Headers) => {
      const used = headers.get("X-Tokens-Used");
      const remaining = headers.get("X-Tokens-Remaining");
      const limit = headers.get("X-Tokens-Limit");
      const tier = headers.get("X-Tokens-Tier");
      const resetsAt = headers.get("X-Tokens-Resets-At");

      // Only update if this was actually a token-consuming response
      if (used === null) return;

      set({
        tokensUsed: safeInt(used, 0),
        tokensRemaining: safeInt(remaining, 0),
        tokensLimit: safeInt(limit, 50),
        tier: tier ?? "free",
        resetsAt: resetsAt ?? null,
        initialized: true,
      });
    },
  },
}));
